<script setup lang="ts">
import {computed, ref, watch} from "vue";
import {ShowcaseItem, ShowcaseType} from "@/core/interfaces/showcase";
import {extensionApi} from "@/container";
import {Skeleton} from "@/core/components/ui/skeleton";

const props = defineProps<{
    extensionId: number;
}>();

const loading = ref(false);
const showcases = ref<ShowcaseItem[]>();

watch(() => props.extensionId, (newVal) => {
    loading.value = true;
    extensionApi()
        .showcase(newVal)
        .then(_showcases => {
            showcases.value = _showcases;
        })
        .finally(() => {
            loading.value = false;
        });
}, {immediate: true});

const potentialShowcase = computed(() => {
    if (!showcases.value) {
        return null;
    }

    return showcases.value.find(showcase => showcase.type === ShowcaseType.POTENTIAL);
});
</script>

<template>
  <div class="bg-secondary-lightest border-y-secondary border-y p-1">
    <Skeleton v-if="loading" class="max-w-2xl mx-auto h-6" />
    <div v-else-if="potentialShowcase" class="mx-auto text-primary text-center">
      <h3>🎯 Potentiel: {{ potentialShowcase.value }} {{ potentialShowcase.label }}</h3>
    </div>
  </div>
</template>

<style scoped>

</style>
